module.exports = __webpack_public_path__ + "static/media/wpl2.png.81d5e7dc.jpg";